import { Checkbox, Flex, Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { TitleWrapper } from './TaskChecks.styles';

export const TaskChecks = () => {
  const { t } = useTranslation('CourseTranslations');
  return (
    <>
      <Flex vertical gap={14} align="flex-start" style={{ paddingLeft: 16 }}>
        <TitleWrapper>{t('TECHNICAL_REQUIREMENTS')}</TitleWrapper>
        <Form.Item valuePropName="checked" name={['checks', 'technical', 'imageAndSound']}>
          <Checkbox>{t('IMAGE_SOUND_QUALITY')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'technical', 'sceneTransitions']}>
          <Checkbox>{t('SCENE_TRANSITION')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'technical', 'intro']}>
          <Checkbox>{t('UCADEMY_INTRO')}</Checkbox>
        </Form.Item>
      </Flex>
      <Flex vertical gap={14} align="flex-start" style={{ paddingLeft: 16, marginTop: 24 }}>
        <TitleWrapper>{t('CONTENT')}</TitleWrapper>
        <Form.Item valuePropName="checked" name={['checks', 'content', 'shortAndClear']}>
          <Checkbox>{t('SHORT_AND_CLEAR')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'content', 'classStructure']}>
          <Checkbox>{t('CLASS_STRUCTURE')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'content', 'correctPresentation']}>
          <Checkbox>{t('GOOD_PRESENTATION')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'content', 'practiceExamples']}>
          <Checkbox>{t('PRACTICAL_EXAMPLES')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'content', 'visualResources']}>
          <Checkbox>{t('VISUAL_RESOURCES')}</Checkbox>
        </Form.Item>
      </Flex>
      <Flex vertical gap={14} align="flex-start" style={{ paddingLeft: 16, marginTop: 24 }}>
        <TitleWrapper>{t('TEACHER_PERFORMANCE')}</TitleWrapper>
        <Form.Item valuePropName="checked" name={['checks', 'performance', 'introduction']}>
          <Checkbox>{t('INTRODUCTION')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'performance', 'voiceTone']}>
          <Checkbox>{t('VOICE_TONE')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'performance', 'notReading']}>
          <Checkbox>{t('DOES_NOT_READ')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'performance', 'useTablet']}>
          <Checkbox>{t('USES_TABLET')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'performance', 'goodPosture']}>
          <Checkbox>{t('GOOD_POSTURE')}</Checkbox>
        </Form.Item>
        <Form.Item valuePropName="checked" name={['checks', 'performance', 'rhetoricalQuestions']}>
          <Checkbox>{t('RHETORICAL_QUESTIONS')}</Checkbox>
        </Form.Item>
      </Flex>
    </>
  );
};
